import ImgDefault from "../assets/svg/profileImg/profileImg.svg";
import ImgDefaultHover from "../assets/svg/profileImg/profileImgHover.svg";
import IconEdit from "../assets/svg/pen-icon-account.svg";
import IconDelete from "../assets/svg/icon-delete-show-account.svg";
import plus from "../assets/svg/profileImg/plus.svg";
import Document from "../assets/svg/tabsImg/Document.svg";
import DocumentShow from "../assets/svg/tabsImg/DocumentShow.svg";
import Location from "../assets/svg/tabsImg/Location.svg";
import LocationShow from "../assets/svg/tabsImg/LocationShow.svg";
import Calling from "../assets/svg/tabsImg/Calling.svg";
import CallingShow from "../assets/svg/tabsImg/CallingShow.svg";
import plusIcon from "../assets/svg/plus-table.svg";
import ImgLogoPerson from "../assets/svg/icon-logo-person.svg";
import {
  apiAddPersons,
  apiDeletePersons,
  apiGetPerson,
  apiGetPersons,
  apiGetPersonsExcel,
  apiUpdatePerson,
} from "../api/personApi";

const defaultCustomerColumns = [
    {
        name: "کد حسابداری",
        key: "accountingCode",
        filterParams: {
            column: "accountingCode",
            columnType: "string",
        },
    },
    {
        name: "نوع شخص",
        key: "isLegal",
        filterParams: {
            column: "id",
            columnType: "string",
            relationModelName: "PersonSetting",
            relationModelKey: "PersonId",
            relationColumn: "value",
            relationStaticColumn: "key",
            relationStaticValue: "isLegal",
        },
        searchType: "status",
        dataKey: [
            {label: "حقیقی", value: "حقیقی", id: 1},
            {label: "حقوقی", value: "حقوقی", id: 2},
        ],
    },
    {
        name: "دسته بندی",
        key: "category",
        filterParams: {
            column: "PersonTypeId",
            columnType: "string",
            relationModelName: "PersonCategory",
            relationColumn: "title",
        },
        searchType: "autocomplete",
        dataKey: {
            column: "personCategories",
            key: "title",
        },
    },
    {
        name: "نام",
        key: "firstName",
        filterParams: {
            column: "firstName",
            columnType: "string",
        },
        searchType: "autocomplete",
        dataKey: {
            column: "persons",
            key: "firstName",
        },
    },
    {
        name: "نام خانوادگی",
        key: "lastName",
        filterParams: {
            column: "lastName",
            columnType: "string",
        },
        searchType: "autocomplete",
        dataKey: {
            column: "persons",
            key: "lastName",
        },
    },
    {
        name: "نام نمایشی",
        key: "nickName",
        filterParams: {
            column: "nickName",
            columnType: "string",
        },
        navigate: "/reports/personalAccountCard?personId=",
        searchType: "autocomplete",
        dataKey: {
            column: "persons",
            key: "nickName",
        },
    },
    {
        name: "موبایل",
        key: "mobile",
        filterParams: {
            column: "id",
            columnType: "string",
            relationModelName: "PersonSetting",
            relationModelKey: "PersonId",
            relationColumn: "value",
            relationStaticColumn: "key",
            relationStaticValue: "mobile",
        },
    },
    {
        name: "تلفن",
        key: "phone",
        filterParams: {
            column: "id",
            columnType: "string",
            relationModelName: "PersonSetting",
            relationModelKey: "PersonId",
            relationColumn: "value",
            relationStaticColumn: "key",
            relationStaticValue: "phone",
        },
    },
];
const defaultPersonnelColumns = [
    {
        name: "کد حسابداری",
        key: "accountingCode",
        filterParams: {
            column: "accountingCode",
            columnType: "string",
        },
        navigate: "/reports/personalAccountCard?personId=",
    },
    {
        name: "دسته بندی",
        key: "category",
        filterParams: {
            column: "PersonTypeId",
            columnType: "string",
            relationModelName: "PersonCategory",
            relationColumn: "title",
        },
        searchType: "autocomplete",
        dataKey: {
            column: "personCategories",
            key: "title",
        },
    },
    {
        name: "نام",
        key: "firstName",
        filterParams: {
            column: "firstName",
            columnType: "string",
        },
        searchType: "autocomplete",
        dataKey: {
            column: "persons",
            key: "firstName",
        },
    },
    {
        name: "نام خانوادگی",
        key: "lastName",
        filterParams: {
            column: "lastName",
            columnType: "string",
        },
        searchType: "autocomplete",
        dataKey: {
            column: "persons",
            key: "lastName",
        },
    },
    {
        name: "نام نمایشی",
        key: "nickName",
        filterParams: {
            column: "nickName",
            columnType: "string",
        },
        navigate: "/reports/personalAccountCard?personId=",
        searchType: "autocomplete",
        dataKey: {
            column: "persons",
            key: "nickName",
        },
    },
    {
        name: "موبایل",
        key: "mobile",
        filterParams: {
            column: "id",
            columnType: "string",
            relationModelName: "PersonSetting",
            relationModelKey: "PersonId",
            relationColumn: "value",
            relationStaticColumn: "key",
            relationStaticValue: "mobile",
        },
    },
    {
        name: "تلفن",
        key: "phone",
        filterParams: {
            column: "id",
            columnType: "string",
            relationModelName: "PersonSetting",
            relationModelKey: "PersonId",
            relationColumn: "value",
            relationStaticColumn: "key",
            relationStaticValue: "phone",
        },
    },
    {
        name: "سمت شغلی",
        key: "jobPosition",
        disableSearch: true,
    },
    {
        name: "حقوق",
        key: "salary",
        price: true,
        disableSearch: true,
    },
];
const defaultProviderColumns = [
    {
        name: "کد حسابداری",
        key: "accountingCode",
        filterParams: {
            column: "accountingCode",
            columnType: "string",
        },
        navigate: "/reports/personalAccountCard?personId=",
    },
    {
        name: "نوع شخص",
        key: "isLegal",
        filterParams: {
            column: "id",
            columnType: "string",
            relationModelName: "PersonSetting",
            relationModelKey: "PersonId",
            relationColumn: "value",
            relationStaticColumn: "key",
            relationStaticValue: "isLegal",
        },
        searchType: "status",
        dataKey: [
            {label: "حقیقی", value: "حقیقی", id: 1},
            {label: "حقوقی", value: "حقوقی", id: 2},
        ],
    },
    {
        name: "دسته بندی",
        key: "category",
        filterParams: {
            column: "PersonTypeId",
            columnType: "string",
            relationModelName: "PersonCategory",
            relationColumn: "title",
        },
        searchType: "autocomplete",
        dataKey: {
            column: "personCategories",
            key: "title",
        },
    },
    {
        name: "نام",
        key: "firstName",
        filterParams: {
            column: "firstName",
            columnType: "string",
        },
        searchType: "autocomplete",
        dataKey: {
            column: "persons",
            key: "firstName",
        },
    },
    {
        name: "نام خانوادگی",
        key: "lastName",
        filterParams: {
            column: "lastName",
            columnType: "string",
        },
        searchType: "autocomplete",
        dataKey: {
            column: "persons",
            key: "lastName",
        },
    },
    {
        name: "نام نمایشی",
        key: "nickName",
        filterParams: {
            column: "nickName",
            columnType: "string",
        },
        navigate: "/reports/personalAccountCard?personId=",
        searchType: "autocomplete",
        dataKey: {
            column: "persons",
            key: "nickName",
        },
    },
    {
        name: "موبایل",
        key: "mobile",
        filterParams: {
            column: "id",
            columnType: "string",
            relationModelName: "PersonSetting",
            relationModelKey: "PersonId",
            relationColumn: "value",
            relationStaticColumn: "key",
            relationStaticValue: "mobile",
        },
    },
    {
        name: "تلفن",
        key: "phone",
        filterParams: {
            column: "id",
            columnType: "string",
            relationModelName: "PersonSetting",
            relationModelKey: "PersonId",
            relationColumn: "value",
            relationStaticColumn: "key",
            relationStaticValue: "phone",
        },
    },
];

export const personIndexData = [
    {
        key: "customer",
        label: "مشتری",
        pluralLabel: "مشتریان",
        title: "مشتریان",
        pageTitle: "اشخاص",
        pageDescription: "لیست مشتریان، کارمندان و تامین کنندگان",
        tableColumns: defaultCustomerColumns,
        disableDateFilter: true,
        actions: {
            add: {
                title: "افزودن",
                icon: plusIcon,
                url: "/persons/add",
            },
            edit: {},
            fetch: apiGetPersons,
            delete: apiDeletePersons,
            excel: {
                export: apiGetPersonsExcel,
                import: apiGetPersonsExcel,
            },
            archive: {
                model: 'person'
            }
        },
    },
    {
        key: "personnel",
        label: "کارمند",
        pluralLabel: "کارمندان",
        title: "کارمندان",
        pageTitle: "اشخاص",
        pageDescription: "لیست مشتریان، کارمندان و تامین کنندگان",
        tableColumns: defaultPersonnelColumns,
        disableDateFilter: true,
        actions: {
            add: {
                title: "افزودن",
                icon: plusIcon,
                url: "/persons/add",
            },
            edit: {},
            fetch: apiGetPersons,
            delete: apiDeletePersons,
            excel: {
                export: apiGetPersonsExcel,
                import: apiGetPersonsExcel,
            },
            archive: {
                model: 'person'
            }
        },
    },
    {
        key: "provider",
        label: "تامین کننده",
        pluralLabel: "تامین کنندگان",
        title: "تامین کنندگان",
        pageTitle: "اشخاص",
        pageDescription: "لیست مشتریان، کارمندان و تامین کنندگان",
        tableColumns: defaultProviderColumns,
        disableDateFilter: true,
        actions: {
            add: {
                title: "افزودن",
                icon: plusIcon,
                url: "/persons/add",
            },
            edit: {},
            fetch: apiGetPersons,
            delete: apiDeletePersons,
            excel: {
                export: apiGetPersonsExcel,
                import: apiGetPersonsExcel,
            },
        },
        archive: {
            model: 'person'
        }
    },
];

export const personFormData = {
    key: "person",
    title: "شخص",
    addFunction: apiAddPersons,
    getFunction: apiGetPerson,
    updateFunction: apiUpdatePerson,
    navigation: {
        title: "افزودن شخص",
        // description: 'ثبت اطلاعات شخص',
        backTitle: "بازگشت",
        backUrl: "/persons",
    },
    summaryInfo: {
        key: "person",
        primaryTitleKey: "nickName",
        addTempTitle: "باز کردن فرم جدید",
        saveTitle: "ذخیره اشخاص",
        defaultImage: ImgLogoPerson,
    },
    tabs: [
        {
            key: "customer",
            name: "مشتری",
            form: {
                main: {
                    wrapperClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7",
                    imagePicker: {
                        active: true,
                        type: "imagePicker",
                        name: "file",
                        wrapperClass: "col-lg-5 col-md-5 col-sm-5 col-xs-12",
                        defaultImage: ImgDefault,
                        defaultImageHover: ImgDefaultHover,
                        editTitle: "انتخاب عکس",
                        editIcon: IconEdit,
                        deleteTitle: "حذف",
                        deleteIcon: IconDelete,
                        addIcon: plus,
                    },
                    accountingCode: {
                        active: true,
                        type: "accountingCode",
                        name: "accountingCode",
                        label: "کد حسابداری",
                        primary: true,
                        maxLength: 20,
                        options: [
                            {
                                label: "اتوماتیک",
                                value: true,
                            },
                            {
                                label: "دستی",
                                value: false,
                            },
                        ],
                    },
                    status: {
                        wrapperClass: "col-lg-5 col-md-5 col-sm-5 col-xs-12",
                        type: "status",
                        name: "active",
                        active: true,
                        primary: true,
                    },
                    inputs: [
                        {
                            type: "personType",
                            name: "personType",
                            label: "نوع شخص",
                            primary: true,
                            required: true,
                        },
                        {
                            name: "nickName",
                            label: "نام نمایشی",
                            maxLength: 64,
                            primary: true,
                            required: true,
                            is: true,
                        },
                        {
                            type: "category",
                            categoryType: "personCategories",
                            name: "personTypeId",
                            label: "دسته بندی",
                            primary: true,
                            editable: true,
                        },
                    ],
                },
                tabs: [
                    {
                        key: "General",
                        name: "عمومی",
                        imgUrl: Document,
                        imgUrlShow: DocumentShow,
                        inputs: [
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                name: "nationalId",
                                label: "کد / شناسه ملی",
                                maxLength: 64,
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                name: "economicCode",
                                label: "کد اقتصادی",
                                maxLength: 64,
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "number",
                                name: "tax",
                                label: "مالیات (درصد)",
                                defaultValue: 9,
                                maxLength: 2,
                            },
                        ],
                    },
                    {
                        key: "address",
                        name: "آدرس",
                        imgUrl: Location,
                        imgUrlShow: LocationShow,
                        inputs: [
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "text",
                                name: "country",
                                label: "کشور",
                                maxLength: 32,
                                placeholder: "ایران",
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "text",
                                name: "state",
                                label: "استان",
                                maxLength: 32,
                                placeholder: "تهران",
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "text",
                                name: "city",
                                label: "شهر",
                                maxLength: 32,
                                placeholder: "تهران",
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                name: "postalCode",
                                type: "number",
                                label: "کد پستی",
                                maxLength: 10,
                                placeholder: "1234567890",
                            },
                            {
                                wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 style-padding-inputs",
                                name: "address",
                                type: "text",
                                label: "آدرس",
                                maxLength: 255,
                                placeholder: "میدان ولیعصر",
                            },
                        ],
                    },
                    {
                        key: "contact",
                        name: "تماس",
                        inputs: [
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "number",
                                name: "phone",
                                label: "تلفن",
                                placeholder: "********021",
                                maxLength: 16,
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "number",
                                name: "mobile",
                                label: "موبایل",
                                placeholder: "*******0912",
                                maxLength: 14,
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "text",
                                name: "email",
                                label: "ایمیل",
                                placeholder: "customer@mail.com",
                                maxLength: 64,
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "text",
                                name: "website",
                                label: "وبسایت",
                                placeholder: "customer.com",
                                maxLength: 128,
                            },
                        ],
                    },
                    {
                        key: "financial",
                        name: "مالی",
                        imgUrl: Calling,
                        imgUrlShow: CallingShow,
                        inputs: [
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "text",
                                name: "bankName",
                                label: "بانک",
                                maxLength: 32,
                                placeholder: "بانک آینده",
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                name: "bankAccountNumber",
                                type: "number",
                                label: "شماره حساب",
                                maxLength: 32,
                                placeholder: "12345678",
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                name: "bankCardNumber",
                                type: "number",
                                label: "شماره کارت",
                                maxLength: 20,
                                placeholder: "1234-5678-1234-5678",
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "number",
                                name: "bankShaba",
                                label: "شماره شبا",
                                maxLength: 64,
                                placeholder: "1234567890",
                            },
                        ],
                    },
                ],
            },
        },
        {
            key: "personnel",
            name: "کارمند",
            form: {
                main: {
                    wrapperClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7",
                    imagePicker: {
                        active: true,
                        wrapperClass: "col-lg-5 col-md-5 col-sm-5 col-xs-12",
                        type: "imagePicker",
                        name: "file",
                        defaultImage: ImgDefault,
                        defaultImageHover: ImgDefaultHover,
                        addIcon: plus,
                        editTitle: "افزودن تصویر",
                        editIcon: IconEdit,
                        deleteTitle: "حذف تصویر",
                        deleteIcon: IconDelete,
                    },
                    accountingCode: {
                        active: true,
                        type: "accountingCode",
                        name: "accountingCode",
                        label: "کد حسابداری",
                        primary: true,
                        maxLength: 20,
                        options: [
                            {
                                label: "اتوماتیک",
                                value: true,
                            },
                            {
                                label: "دستی",
                                value: false,
                            },
                        ],
                    },
                    status: {
                        active: true,
                        primary: true,
                        name: "active",
                        type: "status",
                        wrapperClass: "col-lg-5 col-md-5 col-sm-5 col-xs-12",
                    },
                    inputs: [
                        {
                            wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 align-self-center position-relative",
                            name: "firstName",
                            label: "نام",
                            required: true,
                            primary: true,
                            maxLength: 32,
                        },
                        {
                            wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 align-self-center position-relative",
                            name: "lastName",
                            label: "نام خانوادگی",
                            required: true,
                            primary: true,
                            maxLength: 32,
                        },
                        {
                            name: "nickName",
                            label: "نام نمایشی",
                            maxLength: 64,
                            primary: true,
                            required: true,
                        },
                        {
                            type: "category",
                            categoryType: "personCategories",
                            name: "personTypeId",
                            label: "دسته بندی",
                            primary: true,
                            editable: true,
                        },
                    ],
                },
                tabs: [
                    {
                        key: "General",
                        name: "عمومی",
                        imgUrl: Document,
                        imgUrlShow: DocumentShow,
                        inputs: [
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                name: "jobPosition",
                                label: "سمت شغلی",
                                maxLength: 20,
                                placeholder: "مدیرعامل",
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "currency",
                                noCurrency: true,
                                name: "salary",
                                label: "حقوق ثابت",
                                maxLength: 20,
                                showInput: true,
                            },
                            {
                                wrapperClass:
                                    "col-lg-3 col-md-3 col-sm-3 col-xs-3 ps-2 style-padding-inputs position-relative",
                                type: "datePickerInput",
                                name: "contractStart",
                                label: "تاریخ شروع قرارداد",
                            },
                            {
                                wrapperClass:
                                    "col-lg-3 col-md-3 col-sm-3 col-xs-3 pe-2 style-padding-inputs position-relative",
                                type: "datePickerInput",
                                name: "contractEnd",
                                label: "تاریخ پایان قرارداد",
                            },
                            {
                                wrapperClass:
                                    "col-lg-6 col-md-6 col-sm-6 col-xs-6 align-self-center style-padding-inputs position-relative",
                                type: "optionalDescription",
                                name: "contractDescription",
                                label: "افزودن توضیحات",
                                maxLength: 128,
                            },
                            {
                                wrapperClass:
                                    "col-lg-12 col-md-12 col-sm-12 col-xs-12 style-padding-inputs position-relative",
                                type: "commissionInput",
                                name: "",
                                label: "پورسانت",
                            },
                        ],
                    },
                    {
                        key: "address",
                        name: "آدرس",
                        imgUrl: Location,
                        imgUrlShow: LocationShow,
                        inputs: [
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "text",
                                name: "country",
                                label: "کشور",
                                maxLength: 32,
                                placeholder: "ایران",
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "text",
                                name: "state",
                                label: "استان",
                                maxLength: 32,
                                placeholder: "تهران",
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "text",
                                name: "city",
                                label: "شهر",
                                maxLength: 32,
                                placeholder: "تهران",
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                name: "postalCode",
                                type: "number",
                                label: "کد پستی",
                                maxLength: 10,
                                placeholder: "1234567890",
                            },
                            {
                                wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 style-padding-inputs",
                                name: "address",
                                type: "text",
                                label: "آدرس",
                                maxLength: 255,
                                placeholder: "میدان ولیعصر",
                            },
                        ],
                    },
                    {
                        key: "contact",
                        name: "تماس",
                        inputs: [
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "number",
                                name: "phone",
                                label: "تلفن",
                                placeholder: "********021",
                                maxLength: 16,
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "number",
                                name: "mobile",
                                label: "موبایل",
                                placeholder: "*******0912",
                                maxLength: 14,
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "text",
                                name: "email",
                                label: "ایمیل",
                                placeholder: "customer@mail.com",
                                maxLength: 64,
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "text",
                                name: "website",
                                label: "وبسایت",
                                placeholder: "customer.com",
                                maxLength: 128,
                            },
                        ],
                    },
                    {
                        key: "financial",
                        name: "مالی",
                        imgUrl: Calling,
                        imgUrlShow: CallingShow,
                        inputs: [
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "text",
                                name: "bankName",
                                label: "بانک",
                                maxLength: 32,
                                placeholder: "بانک آینده",
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                name: "bankAccountNumber",
                                type: "number",
                                label: "شماره حساب",
                                maxLength: 32,
                                placeholder: "12345678",
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                name: "bankCardNumber",
                                type: "number",
                                label: "شماره کارت",
                                maxLength: 20,
                                placeholder: "1234-5678-1234-5678",
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "number",
                                name: "bankShaba",
                                label: "شماره شبا",
                                maxLength: 64,
                                placeholder: "1234567890",
                            },
                        ],
                    },
                ],
            },
        },
        {
            key: "provider",
            name: "تامین کننده",
            form: {
                main: {
                    wrapperClass: "col-lg-7 col-md-7 col-sm-7 col-xs-7",
                    imagePicker: {
                        active: true,
                        wrapperClass: "col-lg-5 col-md-5 col-sm-5 col-xs-12",
                        type: "imagePicker",
                        name: "file",
                        defaultImage: ImgDefault,
                        defaultImageHover: ImgDefaultHover,
                        addIcon: plus,
                        editTitle: "افزودن تصویر",
                        editIcon: IconEdit,
                        deleteTitle: "حذف تصویر",
                        deleteIcon: IconDelete,
                    },
                    accountingCode: {
                        active: true,
                        type: "accountingCode",
                        name: "accountingCode",
                        label: "کد حسابداری",
                        primary: true,
                        maxLength: 20,
                        options: [
                            {
                                label: "اتوماتیک",
                                value: true,
                            },
                            {
                                label: "دستی",
                                value: false,
                            },
                        ],
                    },
                    status: {
                        active: true,
                        primary: true,
                        name: "active",
                        type: "status",
                        wrapperClass: "col-lg-5 col-md-5 col-sm-5 col-xs-12",
                    },
                    inputs: [
                        {
                            type: "personType",
                            name: "personType",
                            label: "نوع شخص",
                            primary: true,
                            required: true,
                        },
                        {
                            name: "nickName",
                            label: "نام نمایشی",
                            maxLength: 64,
                            primary: true,
                            required: true,
                        },
                        {
                            type: "category",
                            categoryType: "personCategories",
                            name: "personTypeId",
                            label: "دسته بندی",
                            primary: true,
                            editable: true,
                        },
                    ],
                },
                tabs: [
                    {
                        key: "General",
                        name: "عمومی",
                        imgUrl: Document,
                        imgUrlShow: DocumentShow,
                        inputs: [
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                name: "nationalId",
                                label: "کد / شناسه ملی",
                                maxLength: 64,
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                name: "economicCode",
                                label: "کد اقتصادی",
                                maxLength: 64,
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "number",
                                name: "tax",
                                label: "مالیات (درصد)",
                                defaultValue: 9,
                                maxLength: 2,
                            },
                        ],
                    },
                    {
                        key: "address",
                        name: "آدرس",
                        imgUrl: Location,
                        imgUrlShow: LocationShow,
                        inputs: [
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "text",
                                name: "country",
                                label: "کشور",
                                maxLength: 32,
                                placeholder: "ایران",
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "text",
                                name: "state",
                                label: "استان",
                                maxLength: 32,
                                placeholder: "تهران",
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "text",
                                name: "city",
                                label: "شهر",
                                maxLength: 32,
                                placeholder: "تهران",
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                name: "postalCode",
                                type: "number",
                                label: "کد پستی",
                                maxLength: 10,
                                placeholder: "1234567890",
                            },
                            {
                                wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 style-padding-inputs",
                                name: "address",
                                type: "text",
                                label: "آدرس",
                                maxLength: 255,
                                placeholder: "میدان ولیعصر",
                            },
                        ],
                    },
                    {
                        key: "contact",
                        name: "تماس",
                        inputs: [
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "number",
                                name: "phone",
                                label: "تلفن",
                                placeholder: "********021",
                                maxLength: 16,
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "number",
                                name: "mobile",
                                label: "موبایل",
                                placeholder: "*******0912",
                                maxLength: 14,
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "text",
                                name: "email",
                                label: "ایمیل",
                                placeholder: "customer@mail.com",
                                maxLength: 64,
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "text",
                                name: "website",
                                label: "وبسایت",
                                placeholder: "customer.com",
                                maxLength: 128,
                            },
                        ],
                    },
                    {
                        key: "financial",
                        name: "مالی",
                        imgUrl: Calling,
                        imgUrlShow: CallingShow,
                        inputs: [
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "text",
                                name: "bankName",
                                label: "بانک",
                                maxLength: 32,
                                placeholder: "بانک آینده",
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                name: "bankAccountNumber",
                                type: "number",
                                label: "شماره حساب",
                                maxLength: 32,
                                placeholder: "12345678",
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                name: "bankCardNumber",
                                type: "number",
                                label: "شماره کارت",
                                maxLength: 20,
                                placeholder: "1234-5678-1234-5678",
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "number",
                                name: "bankShaba",
                                label: "شماره شبا",
                                maxLength: 64,
                                placeholder: "1234567890",
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
